module.exports = __webpack_public_path__ + "img/spirit-promotions.90f293ac.png";